import { t } from "i18next";

export const LANGUAGES = [
  { label: "English", code: "en" },
  { label: "Indonesian", code: "id" },
];

export const translate = t as (key: string) => string;

// For keys with {{placeholders}}. A separate cast rather than widening
// translate(): i18next 25's own t typings need TS >= 5 (const type params),
// so this project's TS 4.9 cannot use t's real signature; both exports cast
// to a usable one. Keep translate() options-less so plain lookups stay plain.
export const translateWithVars = t as (
  key: string,
  vars: Record<string, unknown>,
) => string;
